<template>
  <v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Redes de Postos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-slide-x-transition>
            <v-layout justify-end v-show="searchingRede">
              <v-flex xs3>
                <v-select
                  outline
                  hide-details
                  single-line
                  placeholder="Filtrar por"
                  :items="[
                    {
                      value: 'nome__icontains',
                      text: 'Nome da Rede',
                      tipo: 'text',
                      mask: ''
                    },
                    {
                      value: 'is_white_label',
                      text: 'White Label',
                      tipo: 'checklist',
                      mask: ''
                    }
                  ]"
                  item-text="text"
                  v-model="filtro"
                  return-object
                ></v-select>
              </v-flex>
              <v-flex xs4 v-if="filtro && filtro.tipo === 'text'">
                <v-text-field
                  outline
                  hide-details
                  single-line
                  :placeholder="filtro.text"
                  :mask="filtro.mask"
                  v-model="campoPesquisa"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 v-else-if="filtro && filtro.tipo === 'checklist'">
                <v-checkbox
                  v-model="campoPesquisa"
                  color="primary"
                  class="mt-2"
                  :hide-details="campoPesquisa"
                >
                <template slot="label">
                  <span class="body-2 grey--text">{{ filtro.text }}</span>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-slide-x-transition>
          <v-btn icon color="info" @click="searchingRede = !searchingRede">
            <v-icon v-if="!searchingRede">search</v-icon>
            <v-icon v-else>close</v-icon>
          </v-btn>
          <v-tooltip bottom>
            <v-btn @click="dialogFirebase = true" slot="activator" color="info" icon>
              <v-icon>local_fire_department</v-icon>
            </v-btn>
            <span>Gerenciar Projetos Firebase</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn @click="dialogCadRede = true" slot="activator" color="info" icon>
              <v-icon>add</v-icon>
            </v-btn>
            <span>Cadastrar Nova Rede</span>
          </v-tooltip>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="[
            {
              align: 'left',
              sortable: false,
              value: 'icone'
            },
            {
              text: 'Nome',
              align: 'left',
              sortable: false,
              value: 'nome'
            },
            {
              text: 'Posto Matriz',
              sortable: false,
              value: 'matriz'
            },
            {
              text: 'Tipo',
              sortable: false,
              value: 'tipo_rede'
            },
            {
              text: 'Representante',
              sortable: false,
              value: 'matriz.cnpj'
            },
          ]"
          :items="redes"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItens"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="headerCell" slot-scope="{ header }">
            <span class="font-weight-light" v-text="header.text" />
          </template>
          <template slot="items" slot-scope="props">
            <td>
              <v-icon
                :color="
                  props.item.is_white_label ? 'secondary' : ''
                "
              >
                ac_unit
              </v-icon>
            </td>
            <td>{{ props.item.nome }}</td>
            <td class="text-xs-left">
              {{
                props.item.matriz ? props.item.matriz.nome_fantasia : ''
              }}
              <br v-if="props.item.matriz">
              {{ props.item.matriz ? `CNPJ: ${props.item.matriz.cnpj}` : '' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.tipo_rede === 0 ? 'Padrão' : 'Sindicato' }}
            </td>
            <td
              class="text-xs-left"
              v-html="props.item.representante ? `${props.item.representante.nome} ${props.item.representante.sobrenome}`: `Automação ${props.item.empresa_automacao}` "
            ></td>
            <td class="text-xs-left">
              <v-btn flat icon v-if="props.item.ativo" color="green lighten-2">
                <v-icon>check_circle</v-icon>ATIVO
              </v-btn>

              <v-btn flat icon v-else color="error">
                <v-icon>cancel</v-icon>INATIVO
              </v-btn>
            </td>
            <td class="text-xs-right">
              <v-tooltip lazy v-if="props.item.ativo" bottom>
                <v-btn icon color="red" slot="activator" flat @click="desativarRede(props.item)">
                  <v-icon>close</v-icon>
                </v-btn>Desativar Rede
              </v-tooltip>
              <v-tooltip lazy v-else bottom>
                <v-btn icon flat color="green" slot="activator" @click="ativarRede(props.item)">
                  <v-icon>check</v-icon>
                </v-btn>Ativar Rede
              </v-tooltip>
            </td>
            <td>
              <v-tooltip lazy bottom>
                <v-btn icon slot="activator">
                  <v-icon color="info" @click="redeSelecionada = props.item, dialogEditar = true">edit</v-icon>
                </v-btn>Assinatura
              </v-tooltip>
              <v-tooltip lazy bottom>
                <v-btn icon slot="activator">
                  <v-icon color="info" @click="redeSelecionada = props.item, dialogEditar = true">edit</v-icon>
                </v-btn>Editar Dados
              </v-tooltip>
              <v-tooltip lazy bottom>
                <v-btn slot="activator" flat icon color="primary" @click="dialogDetalhes = true, redeSelecionada = props.item">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                Visualizar dados da rede
              </v-tooltip>
              <v-tooltip bottom>
                    <v-btn icon slot="activator" flat color="error" @click="deletarRede(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  <span>Deletar Rede</span>
                </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogDetalhes" v-if="dialogDetalhes" lazy width="600" :fullscreen="$vuetify.breakpoint.xs">
      <dialog-detalhes-da-rede
        :rede="redeSelecionada"
        @fechar="dialogDetalhes = false, redeSelecionada = undefined"
      />
    </v-dialog>
    <v-dialog v-model="dialogEditar" v-if="dialogEditar" width="50em" persistent scrollable>
      <editar-rede
        :rede="redeSelecionada"
        @fechar="dialogEditar = false, redeSelecionada = undefined"
        @error="showError"
        @editado="showInfo"
        @carregar="carregarRedes"
        >
      </editar-rede>
    </v-dialog>
    <v-dialog v-model="dialogFirebase" v-if="dialogFirebase" width="50em" scrollable>
      <dialog-projetos-firebase
        @success="showInfo"
        @error="showError"
        @fechar="dialogFirebase = false"
      />
    </v-dialog>
    <v-dialog v-model="dialogCadRede" v-if="dialogCadRede" width="50em" scrollable>
      <cad-rede
        @success="showInfo"
        @error="showError"
        @fechar="dialogCadRede = false"
      />
    </v-dialog>
    <v-dialog width="500" v-model="dialogDeletar" v-if="dialogDeletar">
      <deletar-rede
        :rede="redeSelecionada"
        @fechar="dialogDeletar = false"
        @success="showInfo"
        @error="showError"
        @carregar="carregarRedes"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DialogDetalhesDaRede from '@/components/dialogs/DetalhesRede'
import EditarRede from '@/components/dialogs/EditarRede'
import DeletarRede from '@/components/dialogs/DeletarRede'
import DialogProjetosFirebase from '@/components/dialogs/ProjetosFirebase'
import CadRede from '@/components/cadastros/CadRede'

export default {
  components: {
    SmartLockMessage,
    DialogDetalhesDaRede,
    EditarRede,
    DialogProjetosFirebase,
    CadRede,
    DeletarRede
  },
  data () {
    return {
      searchingRede: false,
      dialogDetalhes: false,
      ativos: undefined,
      redeSelecionada: undefined,
      dialogEditar: false,
      dialogDeletar: false,
      dialogFirebase: false,
      dialogCadRede: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      filtro: undefined,
      campoPesquisa: undefined,
      redes: [],
      totalItens: 0
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItens == null) {
        return 0
      }
      return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
    }
  },
  watch: {
    'pagination.page' (val) {
      if (val) {
        this.carregarRedes()
      }
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.carregarRedes()
      }
    },
    campoPesquisa () {
      this.carregarRedes()
    },
    filtro (val) {
      this.campoPesquisa = undefined
    },
    searchingRede (val) {
      if (!val) {
        this.filtro = undefined
        this.campoPesquisa = undefined
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.carregarRedes()
    }
  },
  methods: {
    carregarRedes () {
      const data = {}
      data.page = this.pagination.page
      data.page_size = 5
      if (this.filtro && this.campoPesquisa !== undefined) {
        data[`${this.filtro.value}`] = this.campoPesquisa
      }
      this.$store.dispatch('pegarRedes', data).then(json => {
        this.redes = json.results
        this.totalItens = json.count
      })
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    deletarRede (rede) {
      this.redeSelecionada = rede
      this.dialogDeletar = true
    },
    ativarRede (rede) {
      this.$store.dispatch('atualizarTudoRede', {
        id_rede: rede.id_rede,
        ativo: true
      }).then(() => {
        this.carregarRedes()
      })
    },
    desativarRede (rede) {
      this.$store.dispatch('atualizarTudoRede', {
        id_rede: rede.id_rede,
        ativo: false
      }).then(() => {
        this.carregarRedes()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
